import React from "react";
import { MessageCircle, MapPin } from "lucide-react";
import { waLink } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";

const destinations = [
  { name: "Dubai, UAE", img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&q=80", price: "from $499", tag: "Luxury Escapes", desc: "Burj Khalifa, desert safaris, world-class shopping." },
  { name: "Maldives", img: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800&q=80", price: "from $1,299", tag: "Romantic Getaways", desc: "Overwater villas and turquoise lagoons." },
  { name: "Zanzibar, Tanzania", img: "https://images.unsplash.com/photo-1505881502353-a1986add3762?w=800&q=80", price: "from $799", tag: "Family Holidays", desc: "White sand beaches and Stone Town heritage." },
  { name: "Bali, Indonesia", img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800&q=80", price: "from $899", tag: "Romantic Getaways", desc: "Rice terraces, temples and beach clubs." },
  { name: "Cape Town, South Africa", img: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=800&q=80", price: "from $649", tag: "Group Tours", desc: "Table Mountain, wine country and safari." },
  { name: "Phuket, Thailand", img: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=800&q=80", price: "from $749", tag: "Family Holidays", desc: "Islands, street food and tropical resorts." },
  { name: "Singapore", img: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=800&q=80", price: "from $899", tag: "Business Travel", desc: "Gardens by the Bay and Marina Bay Sands." },
  { name: "Europe Multi-city", img: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=800&q=80", price: "from $1,499", tag: "Luxury Escapes", desc: "Paris, Rome, Amsterdam and beyond." },
  { name: "Mauritius", img: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800&q=80", price: "from $1,099", tag: "Romantic Getaways", desc: "Coral lagoons and luxury beach resorts." },
];

export default function HolidayPackages() {
  usePageMeta("Holiday Packages", "Tailor-made holiday packages to Dubai, Zanzibar, Cape Town, Mauritius and beyond — flights, hotels and experiences bundled.");
  return (
    <div className="bg-white">
      <section className="bg-[#0A2E4D] text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <span className="mk-gold-line mb-6 block" />
          <p className="text-xs uppercase tracking-[0.25em] text-[#D4A62A] font-bold mb-3">Holiday Packages</p>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl">Curated escapes, worldwide.</h1>
          <p className="text-slate-300 mt-5 max-w-2xl">Luxury Escapes · Family Holidays · Romantic Getaways · Group Tours · Business Travel Packages</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {destinations.map((d) => (
              <div key={d.name} className="mk-card rounded-md overflow-hidden flex flex-col" data-testid={`destination-${d.name.split(",")[0].toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="relative h-56 overflow-hidden">
                  <img src={d.img} alt={d.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" />
                  <span className="absolute top-3 left-3 bg-[#D4A62A] text-white text-[10px] uppercase tracking-wider px-2.5 py-1 rounded">{d.tag}</span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-1.5 text-xs text-[#475569]"><MapPin size={12} /> {d.name}</div>
                  <h3 className="font-serif-display text-xl text-[#0A2E4D] mt-1">{d.name.split(",")[0]}</h3>
                  <p className="text-sm text-[#475569] mt-2 flex-1">{d.desc}</p>
                  <div className="mt-5 flex items-center justify-between">
                    <span className="text-[#D4A62A] font-medium text-sm">{d.price} / person</span>
                    <a href={waLink(`Hello Makchester Tours & Travel, I would like a holiday package for ${d.name}.`)} target="_blank" rel="noreferrer"
                       className="inline-flex items-center gap-1.5 text-xs bg-[#25D366] hover:bg-[#1ebe57] text-white px-3.5 py-2 rounded-full font-medium transition-colors">
                      <MessageCircle size={12} /> Enquire on WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
